import React, { useState, useEffect } from 'react';
import useStyles from '../../../styles';
import { IconButton, Modal, Backdrop, Fade, Box } from '@material-ui/core';
import Table, { columnType } from '../../../components/ClearingTable/Table';
import { readExerciseNotice } from '../../../services/ExerciseDeclarationService';
import { Close as CloseIcon } from '@material-ui/icons';
import {
  CustomBodyRenderAlign,
  CustomBodyRenderQty,
} from '../../../components/Table/CustomBodyRender';
import { useConfirm } from 'material-ui-confirm';

export default function ExerciseNoticeDetails({
  onClose: handleClose,
  open: isOpen,
  value,
}) {
  const classes = useStyles();

  const [rows, setRows] = useState([]);
  const [pagination, setPagination] = React.useState({});
  const [searchDataCsv, setSearchDataCsv] = React.useState([]);
  const [previousRows, setPreviousRows] = useState(0);
  const [lockTable, setLockTable] = useState(true);
  const confirm = useConfirm();

  const columns = [
    {
      name: 'symbol',
      label: 'Symbol',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      name: 'exerciseQty',
      label: 'Exercise Qty',
      type: columnType.quantity,
      options: {
        customBodyRender: CustomBodyRenderQty,
      },
    },
    {
      name: 'contraryId',
      label: 'ID',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      name: 'a-selectAll',
      label: 'Select All',
      options: {
        display: true,
        print: false,
        download: false,
        filter: false,
        setCellHeaderProps: () => ({
          style: {
            width: '0px',
            display: 'table-cell',
            padding: 0,
            pointerEvents: 'none',
            fontSize: 0,
          },
        }),
      },
    },
  ];

  const options = {
    serverSide: true,
    selectableRows: 'none',
  };

  useEffect(
    () => {
      async function init() {
        handleSearch()
      }

      if (isOpen) {
        init();
      }
    }, // eslint-disable-next-line
    [isOpen]
  );

  const getCsvData = async () => {
    if (lockTable === true) {
      return [];
    }
    const MAX_RECORDS_ALLOWED = 100000;

    let paginationCopy = {
      ...pagination,
      reload: false,
      pageNo: 0,
      rowsPerPage: MAX_RECORDS_ALLOWED,
    };

    const data = await readExerciseNotice(searchDataCsv, paginationCopy);

    if (data.declarationDetailsList.length >= MAX_RECORDS_ALLOWED) {
      confirm({
        description:
          'Only ' +
          MAX_RECORDS_ALLOWED.toLocaleString() +
          ' items will be downloaded, if you need more please use the metabase.',
        confirmationText: 'I understand',
      });
    }

    return data.declarationDetailsList;
  };

  const handleSearch = async (paginationChange) => {
    try {
      if (paginationChange !== true) {
        setLockTable(false);
      }
      if (paginationChange === true) {
        if (lockTable === true) {
          return;
        }
      }
      let paginationCopy = {
        ...pagination,
        reload: false,
        pageNo: paginationChange === true ? pagination.pageNo : 0,
        rowsPerPage: pagination.rowsPerPage || 100,
      };
      if (previousRows !== 0) {
        if (previousRows < pagination.rowsPerPage * pagination.pageNo) {
          paginationCopy.pageNo = 0;
        }
      }
      if (paginationChange !== true) {
        paginationCopy.filterNames = [];
        paginationCopy.filterValues = [];
      }
      const data = await readExerciseNotice(value, paginationCopy);
      setSearchDataCsv(value);
      setPreviousRows(data.summary.totalRows);
      paginationCopy.count = data.summary.totalRows;
      setPagination(paginationCopy);
      setRows(data.declarationDetailsList);
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modalBackdrop}
      open={isOpen}
      onClose={() => {
        handleClose();
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={isOpen}>
        <div className={classes.tableModalFull}>
          <Box component="div" mt={2}>
            <Table
              title="EXERCISE NOTICE DETAILS"
              data={rows}
              columns={columns}
              options={options}
              onSearch={handleSearch}
              pagination={pagination}
              setPagination={setPagination}
              getCsvData={getCsvData}
            />
          </Box>

          <div className={classes.modalFooter}>
            <div className={classes.grdCellNone} style={{ marginRight: 10 }}>
              <div className={classes.modalCloseIcon} style={{ marginRight: 10 }}>
                <IconButton
                  aria-label="close"
                  onClick={() => {
                    handleClose();
                  }}
                >
                  <CloseIcon style={{ color: '#f1f1f1' }} />
                </IconButton>
              </div>
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  );
}
